import { forwardRef } from 'react'

import { SystemIconTemplate } from '../../template/system-icon-template'
import { IconProps } from '../../types/types'

export const WarningCircleSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<SystemIconTemplate ref={ref} {...props}>
			<path
				d="M12 8.8V13M12 15.2H12.008M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z"
				stroke="currentColor"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</SystemIconTemplate>
	)
})
